import { apiClient } from "./client";

export const listAdminAgents = (params = {}) =>
  apiClient.get("/admin-actions/agents", { params }).then((r) => r.data);

export const getAgentSubscriptions = (agentId) =>
  apiClient.get(`/admin-actions/agents/${agentId}/subscriptions`).then((r) => r.data);

export const swapCounty = (agentId, data) =>
  apiClient.put(`/admin-actions/agents/${agentId}/swap-county`, data).then((r) => r.data);

export const adminCancelLeadType = (agentId, data) =>
  apiClient.post(`/admin-actions/agents/${agentId}/cancel-lead-type`, data).then((r) => r.data);
